import React from 'react';
import { WithIcon } from './WithIcon';

export const IconSearch = WithIcon(
  'Search',
  '0 0 1024 1024',
  <path
    transform="scale(1, -1) translate(0, -960)"
    d="M853.4 48h87.8l-276.8 276.8c105.4 126 99 314.4-19.2 432.6-125 125-328.6 125-453.8 0-125-125-125-328.6 0-453.8 91-91 223.4-115.8 337-74.4l-49.2 49.2c-85-20.4-178.2 2.4-244.4 68.6-101.2 101.2-101.2 265.8 0 367s265.8 101.2 367 0 101.2-265.8 0-367c-7.8-7.8-16.2-15.2-24.8-21.8l0.6-0.6-0.6-0.4 276.4-276.2z"
  />
);
